import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'pickuptype',
  templateUrl: 'pickuptype.component.html'
})
export class PickuptypeComponent implements OnInit {
  @Output() onPickuptypeSelected: EventEmitter<any> = new EventEmitter();
  public pickupOptions = [];
  locationImageUrlPrefix = '../assets/images/location/';

  ngOnInit() {
    this.pickupOptions.push({
      pickupType: 'Dine In',
      pickupImage: this.locationImageUrlPrefix + 'Dine In Icon.png',
      pickupTypeId: 1
    });

    this.pickupOptions.push({
      pickupType: 'Drive Thru',
      pickupImage: this.locationImageUrlPrefix + 'Drive Thru Icon.png',
      pickupTypeId: 2
    });

    this.pickupOptions.push({
      pickupType: 'Take Out',
      pickupImage: this.locationImageUrlPrefix + 'Take Out Icon.png',
      pickupTypeId: 3
    });
  }

  selectPickuptype(pickupTypeId) {
    this.onPickuptypeSelected.emit(pickupTypeId);
  }
}
